module.exports = __webpack_public_path__ + "img/no-internet.dc063dd9.svg";